export default __webpack_public_path__ + "static/timeline-image-02-b8ca6eadb59993d373c4fe0e99e19000.jpg";